module.exports = window["braintree"]["dataCollector"];